<template>
  <div class="mt-3 relative">
    <z-loading :active="isLoading" :is-full-page="false" />
    <div v-if="!scanResults">
      <p>{{ $t('ScanYourID') }}</p>

      <MBScan ref="mbScan" doc-type="scan-id" @results="onScanResult" />

      <z-button class="mt-6 w-full" @click="startScan">
        {{ $t('StartScan') }}
      </z-button>

      <tutorial
        :tutorial-name="
          $store.state.updateIdInfoResult.result.status ===
          'User is not eligible'
            ? 'enable_auth'
            : 'new_user'
        "
        v-if="
          $store.state.updateIdInfoResult &&
          $store.state.updateIdInfoResult.result
        " />
    </div>
    <div v-else>
      <p>{{ $t('ScanSuccessful') }}</p>
    </div>
  </div>
</template>

<script>
import ZButton from '@/zain-component-library/src/lib-components/ZButton'
import ZLoading from '@/zain-component-library/src/lib-components/ZLoading'
import api from '@/api'
import Tutorial from '@/components/Tutorial'
import MBScan from '@/mixins/MBScan'

export default {
  name: 'ScanFlow',
  components: { MBScan, Tutorial, ZLoading, ZButton },
  data() {
    return {
      isLoading: false,
      scanResults: null
    }
  },
  methods: {
    async startScan() {
      await this.$refs.mbScan.startScan()
    },

    async onScanResult(results) {
      if (!results || !results.mrz || !results.mrz.rawMRZString) {
        // clear invalid results to re-scan
        this.$refs.mbScan.scanResults = null
        this.$refs.mbScan.firstSideDone = false
        return
      }

      try {
        this.scanResults = results

        this.isLoading = true

        let info = {
          dateOfBirth: this.scanResults.dateOfBirth,
          dateOfExpiry: this.scanResults.dateOfExpiry,
          dateOfExpiryPermanent: this.scanResults.dateOfExpiryPermanent,
          documentAdditionalNumber: this.scanResults.documentAdditionalNumber,
          documentOptionalAdditionalNumber:
          this.scanResults.documentOptionalAdditionalNumber,
          documentNumber: this.scanResults.documentNumber,
          fullName: this.scanResults.fullName,
          id_back: this.scanResults.mrz.rawMRZString,
          nationality: this.scanResults.nationality,
          personalIdNumber: this.scanResults.personalIdNumber,
          placeOfBirth: this.scanResults.placeOfBirth,
          profession: this.scanResults.profession,
          race: this.scanResults.race,
          religion: this.scanResults.religion,
          residentialStatus: this.scanResults.residentialStatus,
          sex: this.scanResults.sex,
          recognitionMode: this.scanResults.recognitionMode,
          backImageAnalysisResult: this.scanResults.backImageAnalysisResult,
          backProcessingStatus: this.scanResults.backProcessingStatus,
          processingStatus: this.scanResults.processingStatus,
          scanningFirstSideDone: this.scanResults.scanningFirstSideDone,
          idFront: this.scanResults.fullDocumentFrontImage,
          idBack: this.scanResults.fullDocumentBackImage
        }

        const eventParams = {
          eventAction: 'kyc-submit-upsert',
          eventCategory: 'kyc-service'
        }
        try {
          await api.upsertCustomer(info)
          await this.$store.dispatch('sendAnalyticsEvent', {
            ...eventParams,
            eventLabel: 'success'
          })
        } catch (e) {
          this.isLoading = false
          console.error('error happened in upsert', e)
          this.$store.state.queryIdInfoResult = 'error'

          await this.$store.dispatch('sendAnalyticsEvent', {
            ...eventParams,
            eventLabel: 'failure ' + e.message
          })
        } finally {
          this.isLoading = false
        }
      } catch (e) {
        console.error(e)
        this.$store.state.queryIdInfoResult = 'error'
      }
    }
  },
  async mounted() {
    this.$store.state.navText = ''
  }
}
</script>
